import {Component} from '@angular/core';
import {AbstractDynamicFormFieldDirective} from './abstract-dynamic-form-field.directive';
import {arrayToStr, strToArray} from './Util';

@Component({
  selector: 'app-dff-checkbox-group',
  templateUrl: './dff-checkbox-group.component.html',
  styleUrls: ['./dff-checkbox-group.component.scss']
})
export class DffCheckboxGroupComponent extends AbstractDynamicFormFieldDirective {

  validate(value: string): string[] {
    if (this.field.isRequiredAll && !this.isAllChecked()) {
      return ['validate_required_all'];
    }
    if (this.field.isRequired && !this.isOneChecked()) {
      return ['validate_required'];
    }
    return [];
  }

  writeValue(value: string) {
    const ids = strToArray<string>(value);
    for (const option of this.field.options) {
      option.checked = ids.includes(option.id);
    }
  }

  isAllChecked() {
    let ret = true;
    this.field.options.forEach(option => ret = option.checked && ret);
    return ret;
  }

  isOneChecked(): boolean {
    for (const option of this.field.options) {
      if (option.checked) {
        return true;
      }
    }

    return false;
  }

  changed() {
    const ids = this.field.options.filter(x => x.checked).map(x => x.id);
    this.changeValue(arrayToStr(ids));
  }
}
